import React, { ReactElement } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export default function NativeActivityIndicator(_props: {
  color?: string;
  style?: StyleProp<ViewStyle>;
}): ReactElement {
  return <></>;
}
